<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'

withDefaults(
  defineProps<{
    label: string
    optional?: boolean
  }>(),
  {
    optional: false,
  },
)
</script>

<template>
  <div :class="optional ? 'gap-1' : ''" class="flex mb-0.25 font-sans font-medium">
    <label-base size="sm" class="self-center">{{ label }}</label-base>
    <label-base v-if="optional" size="xs" color="stone" class="self-center">(Optional)</label-base>
  </div>
</template>

<style scoped></style>
